import { type SyntheticEvent, useState } from 'react';

import type { DeviceSyncFormProps } from '@/pages/Administration/Devices/SyncDevices/SyncDevices.types';

import DeviceAccordionRow from '../DeviceAccordionRow/DeviceAccordionRow';
import { useSyncDevicesDialog } from '../SyncDevices.hooks';
import useStyles from '../SyncDevicesForm.styles';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '../styled/Accordion.styled';

const OrgRow = (props: DeviceSyncFormProps) => {
  const { classes } = useStyles();
  const { mode } = useSyncDevicesDialog();
  const { orgName, items } = props;
  const [expanded, setExpanded] = useState<string | false>();

  const handleChange =
    (panel: string) => (event: SyntheticEvent, newExpanded: boolean) => {
      event.stopPropagation();
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <Accordion
      className={classes.syncAccordion}
      expanded={expanded === `panel-${orgName}`}
      onChange={handleChange(`panel-${orgName}`)}
    >
      <AccordionSummary
        aria-controls="panel1d-content"
        id={`panel-summary-${orgName}`}
        sx={{
          '& .MuiAccordionSummary-content': {
            alignItems: 'center',
            position: 'relative'
          }
        }}
      >
        {orgName}
      </AccordionSummary>
      <AccordionDetails id={`panel-details-${orgName}`}>
        <div id={`panel-details-${orgName}-container`}>
          {mode === 'newSyncDevices' &&
            items?.map((item) => (
              <DeviceAccordionRow deviceRow={item} key={item.hostName} />
            ))}

          {mode === 'confirmSyncDevices' &&
            items?.map((item) =>
              item?.isSelected ? (
                <DeviceAccordionRow deviceRow={item} key={item.hostName} />
              ) : null
            )}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default OrgRow;
